import React, { useEffect, useMemo, useRef, useState } from "react";
import "./newFlightSearch.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Nav from "../NavBar/Nav";
import axios from "axios";
import base_url from "../../api/bootapi";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import SearchIcon from "@mui/icons-material/Search";
import { DatePicker } from "@mantine/dates";
import {
  Menu,
  Button,
  Text,
  Modal,
  Accordion,
  Slider,
  Skeleton,
  Loader,
  RangeSlider,
  Checkbox,
  Switch,
} from "@mantine/core";
import debounce from "lodash.debounce";
import { useDisclosure } from "@mantine/hooks";

import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import AdjustIcon from "@mui/icons-material/Adjust";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import AirplanemodeActiveOutlinedIcon from "@mui/icons-material/AirplanemodeActiveOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import { useMediaQuery } from "@mantine/hooks";
import { Controller, useForm } from "react-hook-form";
import FlightItem from "./FlightItem";
import FlightDetails from "./FlightDetails";

const Stops = ({ stops, setStops }) => {
  const handleChange = (e) => {
    setStops(e.target.value);
  };
  return (
    <div className="filter-dropdown-wrapper">
      <div className="filter-header-wrapper">
        <span>Stops</span>
      </div>
      <div className="filter-radio-wrapper">
        <label className="filter-radio-input">
          <input
            type="radio"
            name="stops"
            value="any"
            onChange={handleChange}
            checked={stops === "any"}
          />{" "}
          Any number of stops
        </label>

        <label className="filter-radio-input">
          <input
            type="radio"
            name="stops"
            value="1"
            onChange={handleChange}
            checked={stops === "1"}
          />{" "}
          Nonstop only
        </label>

        <label className="filter-radio-input">
          <input
            type="radio"
            name="stops"
            value="2"
            onChange={handleChange}
            checked={stops === "2"}
          />{" "}
          1 stop or fewer
        </label>

        <label className="filter-radio-input">
          <input
            type="radio"
            name="stops"
            value="3"
            onChange={handleChange}
            checked={stops === "3"}
          />{" "}
          2 stop or fewer
        </label>
      </div>
    </div>
  );
};

const Times = ({
  departureTime,
  setDepartureTime,
  arrivalTime,
  setArrivalTime,
}) => {
  const formatHourLabel = (val) => {
    const hour = val % 24;
    const suffix = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${formattedHour} ${suffix}`;
  };

  return (
    <div className="filter-dropdown-wrapper" style={{ width: "300px" }}>
      <div className="filter-header-wrapper">
        <span>Times</span>
      </div>
      <div>
        <div style={{ marginTop: "20px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FlightTakeoffIcon /> <span>Departure</span>
          </div>

          <RangeSlider
            mt={20}
            min={0}
            max={24}
            step={1}
            value={departureTime}
            onChange={setDepartureTime}
            label={formatHourLabel}
            minRange={1}
          />
        </div>

        <div style={{ marginTop: "20px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FlightLandIcon /> <span>Arrival</span>
          </div>

          <RangeSlider
            mt={20}
            min={0}
            max={24}
            step={1}
            defaultValue={[0, 24]}
            value={arrivalTime}
            onChange={setArrivalTime}
            label={formatHourLabel}
            minRange={1}
          />
        </div>
      </div>
    </div>
  );
};

const Bags = ({ bags, setBags }) => {
  return (
    <div className="filter-dropdown-wrapper" style={{ width: "200px" }}>
      <div className="filter-header-wrapper">
        <span>Bags</span>
      </div>
      <div className="person-item">
        <div className="person-category">
          <span className="person-main">Bags</span>
        </div>
        <div className="count-wrapper">
          <button
            className="count-btn"
            disabled={bags === 0}
            style={{ opacity: bags === 0 ? 0.6 : 1 }}
            onClick={() => setBags((prev) => prev - 1)}
          >
            <RemoveIcon />
          </button>
          <span className="count-value">{bags}</span>
          <button
            className="count-btn"
            disabled={bags === 2}
            style={{ opacity: bags === 2 ? 0.6 : 1 }}
            onClick={() => setBags((prev) => prev + 1)}
          >
            <AddIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

const Price = ({ price, setPrice }) => {
  return (
    <div className="filter-dropdown-wrapper" style={{ width: "300px" }}>
      <div className="filter-header-wrapper">
        <span>Price</span>
      </div>

      <div>
        <span>{price < 99999 ? "up to " + price : "All prices"}</span>

        <Slider value={price} onChange={setPrice} min={50} max={99999} />
      </div>
    </div>
  );
};

const Duration = ({ duration, setDuration }) => {
  return (
    <div className="filter-dropdown-wrapper" style={{ width: "300px" }}>
      <div className="filter-header-wrapper">
        <span>Duration</span>
      </div>

      <div>
        <span>
          Flight duration .{" "}
          {duration < 45 ? "under " + duration + " hr" : "any"}
        </span>

        <Slider value={duration} onChange={setDuration} min={2} max={45} />
      </div>
    </div>
  );
};

const Airlines = ({
  airlines,
  setAirlines,
  checkedAirline,
  setCheckedAirline,
}) => {
  // useEffect(() => {
  //   if (checkedAirline) {
  //     setAirlines((prev) =>
  //       prev.map((airline) => {
  //         return { ...airline, selected: true };
  //       })
  //     );
  //   } else {
  //     setAirlines((prev) =>
  //       prev.map((airline) => {
  //         return { ...airline, selected: false };
  //       })
  //     );
  //   }
  // }, [checkedAirline]);

  useEffect(() => {
    const hasUnselected = airlines.some((item) => item.selected === false);
    if (hasUnselected) {
      setCheckedAirline(false);
    } else {
      setCheckedAirline(true);
    }
  }, [airlines]);

  const handleSwitchChange = (e) => {
    if (e.currentTarget.checked) {
      setAirlines((prev) =>
        prev.map((airline) => {
          return { ...airline, selected: true };
        })
      );
    } else {
      setAirlines((prev) =>
        prev.map((airline) => {
          return { ...airline, selected: false };
        })
      );
    }

    setCheckedAirline(e.currentTarget.checked);
  };

  return (
    <div className="filter-dropdown-wrapper" style={{ width: "300px" }}>
      <div className="filter-header-wrapper">
        <span>Airlines</span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Select all airlines</span>
        <Switch
          checked={checkedAirline}
          disabled={airlines.length === 0}
          onChange={handleSwitchChange}
        />
      </div>

      <div className="checkbox-list-wrapper">
        {airlines.map((airline, index) => {
          return (
            <label key={index} className="checkbox-wrappper">
              <Checkbox
                checked={airline.selected}
                onChange={(event) => {
                  const updateAirlines = [...airlines];
                  updateAirlines[index].selected = event.currentTarget.checked;

                  setAirlines(updateAirlines);
                }}
              />

              <span>{airline.name}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

const Currency = ({ currency, setCurrency }) => {
  const currencyList = [
    { name: "Albanian Lek", code: "ALL", symbol: "L" },
    { name: "Algerian Dinar", code: "DZD", symbol: "دج" },
    { name: "Argentine Peso", code: "ARS", symbol: "$" },
    { name: "Armenian Dram", code: "AMD", symbol: "֏" },
    { name: "Aruban Florin", code: "AWG", symbol: "ƒ" },
    { name: "Australian Dollar", code: "AUD", symbol: "A$" },
    { name: "Azerbaijani Manat", code: "AZN", symbol: "₼" },
    { name: "Bahamian Dollar", code: "BSD", symbol: "B$" },
    { name: "Bahraini Dinar", code: "BHD", symbol: "ب.د" },
    { name: "Belarusian Ruble", code: "BYN", symbol: "Br" },
    { name: "Bermudan Dollar", code: "BMD", symbol: "$" },
    { name: "Bosnia-Herzegovina Convertible Mark", code: "BAM", symbol: "KM" },
    { name: "Brazilian Real", code: "BRL", symbol: "R$" },
    { name: "British Pound", code: "GBP", symbol: "£" },
    { name: "Bulgarian Lev", code: "BGN", symbol: "лв" },
    { name: "CFP Franc", code: "XPF", symbol: "₣" },
    { name: "Canadian Dollar", code: "CAD", symbol: "C$" },
    { name: "Chilean Peso", code: "CLP", symbol: "$" },
    { name: "Chinese Yuan", code: "CNY", symbol: "¥" },
    { name: "Colombian Peso", code: "COP", symbol: "$" },
    { name: "Costa Rican Colón", code: "CRC", symbol: "₡" },
    { name: "Cuban Peso", code: "CUP", symbol: "$" },
    { name: "Czech Koruna", code: "CZK", symbol: "Kč" },
    { name: "Danish Krone", code: "DKK", symbol: "kr" },
    { name: "Dominican Peso", code: "DOP", symbol: "RD$" },
    { name: "Egyptian Pound", code: "EGP", symbol: "£" },
    { name: "Euro", code: "EUR", symbol: "€" },
    { name: "Georgian Lari", code: "GEL", symbol: "₾" },
    { name: "Hong Kong Dollar", code: "HKD", symbol: "HK$" },
    { name: "Hungarian Forint", code: "HUF", symbol: "Ft" },
    { name: "Icelandic Króna", code: "ISK", symbol: "kr" },
    { name: "Indian Rupee", code: "INR", symbol: "₹" },
    { name: "Indonesian Rupiah", code: "IDR", symbol: "Rp" },
    { name: "Iranian Rial", code: "IRR", symbol: "﷼" },
    { name: "Israeli New Shekel", code: "ILS", symbol: "₪" },
    { name: "Jamaican Dollar", code: "JMD", symbol: "J$" },
    { name: "Japanese Yen", code: "JPY", symbol: "¥" },
    { name: "Jordanian Dinar", code: "JOD", symbol: "د.ا" },
    { name: "Kazakhstani Tenge", code: "KZT", symbol: "₸" },
    { name: "Kuwaiti Dinar", code: "KWD", symbol: "د.ك" },
    { name: "Lebanese Pound", code: "LBP", symbol: "ل.ل" },
    { name: "Macedonian Denar", code: "MKD", symbol: "ден" },
    { name: "Malaysian Ringgit", code: "MYR", symbol: "RM" },
    { name: "Mexican Peso", code: "MXN", symbol: "$" },
    { name: "Moldovan Leu", code: "MDL", symbol: "L" },
    { name: "Moroccan Dirham", code: "MAD", symbol: "د.م." },
    { name: "New Taiwan Dollar", code: "TWD", symbol: "NT$" },
    { name: "New Zealand Dollar", code: "NZD", symbol: "NZ$" },
    { name: "Norwegian Krone", code: "NOK", symbol: "kr" },
    { name: "Omani Rial", code: "OMR", symbol: "ر.ع." },
    { name: "Pakistani Rupee", code: "PKR", symbol: "₨" },
    { name: "Panamanian Balboa", code: "PAB", symbol: "B/." },
    { name: "Peruvian Sol", code: "PEN", symbol: "S/" },
    { name: "Philippine Peso", code: "PHP", symbol: "₱" },
    { name: "Polish Zloty", code: "PLN", symbol: "zł" },
    { name: "Qatari Riyal", code: "QAR", symbol: "ر.ق" },
    { name: "Romanian Leu", code: "RON", symbol: "lei" },
    { name: "Russian Ruble", code: "RUB", symbol: "₽" },
    { name: "Saudi Riyal", code: "SAR", symbol: "ر.س" },
    { name: "Serbian Dinar", code: "RSD", symbol: "дин." },
    { name: "Singapore Dollar", code: "SGD", symbol: "S$" },
    { name: "South African Rand", code: "ZAR", symbol: "R" },
    { name: "South Korean Won", code: "KRW", symbol: "₩" },
    { name: "Swedish Krona", code: "SEK", symbol: "kr" },
    { name: "Swiss Franc", code: "CHF", symbol: "CHF" },
    { name: "Thai Baht", code: "THB", symbol: "฿" },
    { name: "Turkish Lira", code: "TRY", symbol: "₺" },
    { name: "US Dollar", code: "USD", symbol: "$" },
    { name: "Ukrainian Hryvnia", code: "UAH", symbol: "₴" },
    { name: "United Arab Emirates Dirham", code: "AED", symbol: "د.إ" },
    { name: "Vietnamese Dong", code: "VND", symbol: "₫" },
  ];

  const [filteredCurrency, setFilteredCurrency] = useState(currencyList);

  function searchCurrency(query) {
    const lowerQuery = query.toLowerCase();
    const updatedFilteredCurrency = currencyList.filter(
      (currency) =>
        currency.name.toLowerCase().includes(lowerQuery) ||
        currency.code.toLowerCase().includes(lowerQuery)
    );

    setFilteredCurrency(updatedFilteredCurrency);
  }
  return (
    <div className="filter-dropdown-wrapper" style={{ width: "300px" }}>
      <div className="filter-header-wrapper">
        <span>Currency</span>
      </div>

      <input
        placeholder="Search"
        className="currency-input"
        onChange={(e) => searchCurrency(e.target.value)}
      />

      <div className="currency-wrapper">
        {filteredCurrency.map((currency, index) => {
          return (
            <span
              key={index}
              className="currency-item"
              onClick={() => setCurrency(currency)}
            >
              {currency.name}
            </span>
          );
        })}
      </div>
    </div>
  );
};

const Airports = ({
  layoverStops,
  setLayoverStops,
  checkedAirport,
  setCheckedAirport,
}) => {
  useEffect(() => {
    const hasUnselected = layoverStops.some((item) => item.selected === false);
    if (hasUnselected) {
      setCheckedAirport(false);
    } else {
      setCheckedAirport(true);
    }
  }, [layoverStops]);

  const handleSwitchChange = (e) => {
    if (e.currentTarget.checked) {
      setLayoverStops((prev) =>
        prev.map((airport) => {
          return { ...airport, selected: true };
        })
      );
    } else {
      setLayoverStops((prev) =>
        prev.map((airport) => {
          return { ...airport, selected: false };
        })
      );
    }

    setCheckedAirport(e.currentTarget.checked);
  };

  return (
    <div className="filter-dropdown-wrapper" style={{ width: "300px" }}>
      <div className="filter-header-wrapper">
        <span>Connecting Airports</span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Select all stops</span>
        <Switch
          checked={checkedAirport}
          disabled={layoverStops.length === 0}
          onChange={handleSwitchChange}
        />
      </div>

      <div className="checkbox-list-wrapper">
        {layoverStops.map((airport, index) => {
          return (
            <label key={index} className="checkbox-wrappper">
              <Checkbox
                checked={airport.selected}
                onChange={(event) => {
                  const updateAirlines = [...layoverStops];
                  updateAirlines[index].selected = event.currentTarget.checked;

                  setLayoverStops(updateAirlines);
                }}
              />

              <span>{airport.name}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

const MultiCityItem = ({
  multiFlight,
  index,
  multiCity,
  setMultiCity,
  defaultOptions,
  setDefaultOptions,
  initialAirports,
  debouncedLoadOptions,
  handleMultiCityDateAction,
  formatDate,
  rotation,
}) => {
  const departureRef = useRef(null);
  const arrivalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const updated = [...multiCity];
      let changed = false;

      if (
        multiFlight.showDeparture &&
        departureRef.current &&
        !departureRef.current.contains(event.target)
      ) {
        updated[index].showDeparture = false;
        changed = true;
      }

      if (
        multiFlight.showArrival &&
        arrivalRef.current &&
        !arrivalRef.current.contains(event.target)
      ) {
        updated[index].showArrival = false;
        changed = true;
      }

      if (changed) {
        setMultiCity(updated);
      }
    };

    setDefaultOptions(initialAirports);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [multiFlight, multiCity]);

  return (
    <div className="search_section">
      <div className="place-wrapper">
        <div
          className="from-place"
          ref={departureRef}
          onClick={() => {
            const updated = [...multiCity];
            updated[index].showDeparture = true;
            setMultiCity(updated);
          }}
        >
          <AdjustIcon />
          <div className="flight-place-name">
            {multiFlight?.departure?.name || "Select Airport"}
          </div>
          {multiFlight.showDeparture && (
            <div className="airport-dropdown">
              <div className="search-input-wrapper">
                <span>
                  <AdjustIcon />
                </span>
                <input
                  type="text"
                  placeholder="Where from?"
                  autoFocus
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length === 0) {
                      setDefaultOptions(initialAirports);
                      return;
                    }
                    debouncedLoadOptions(inputValue, (options) => {
                      setDefaultOptions(options);
                    });
                  }}
                />
              </div>
              <div className="search-flight-list">
                {defaultOptions.length > 0 ? (
                  defaultOptions.map((option, i) => (
                    <span
                      className="flight-dropdown-item"
                      key={i}
                      onClick={(e) => {
                        e.stopPropagation();
                        const updated = [...multiCity];
                        updated[index] = {
                          ...updated[index],
                          departure: option,
                          showDeparture: false,
                        };
                        setMultiCity(updated);
                      }}
                    >
                      <AirplanemodeActiveOutlinedIcon />
                      {option.name}{" "}
                      <span className="iata_code">({option.iata})</span>
                    </span>
                  ))
                ) : (
                  <span
                    style={{
                      padding: "10px",
                      display: "block",
                      textAlign: "center",
                    }}
                  >
                    No matching locations found
                  </span>
                )}
              </div>
            </div>
          )}
        </div>

        <div
          className="from-place"
          ref={arrivalRef}
          onClick={() => {
            const updated = [...multiCity];
            updated[index].showArrival = true;
            setMultiCity(updated);
          }}
        >
          <LocationOnOutlinedIcon />
          <div className="flight-place-name">
            {multiFlight?.arrival?.name || "Select Airport"}
          </div>
          {multiFlight.showArrival && (
            <div className="airport-dropdown">
              <div className="search-input-wrapper">
                <span>
                  <LocationOnOutlinedIcon />
                </span>
                <input
                  type="text"
                  placeholder="Where to?"
                  autoFocus
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length === 0) {
                      setDefaultOptions(initialAirports);
                      return;
                    }
                    debouncedLoadOptions(inputValue, (options) => {
                      setDefaultOptions(options);
                    });
                  }}
                />
              </div>
              <div className="search-flight-list">
                {defaultOptions.length > 0 ? (
                  defaultOptions.map((option, i) => (
                    <span
                      className="flight-dropdown-item"
                      key={i}
                      onClick={(e) => {
                        e.stopPropagation();
                        const updated = [...multiCity];
                        updated[index] = {
                          ...updated[index],
                          arrival: option,
                          showArrival: false,
                        };
                        setMultiCity(updated);
                      }}
                    >
                      <AirplanemodeActiveOutlinedIcon />
                      {option.name}{" "}
                      <span className="iata_code">({option.iata})</span>
                    </span>
                  ))
                ) : (
                  <span
                    style={{
                      padding: "10px",
                      display: "block",
                      textAlign: "center",
                    }}
                  >
                    No matching locations found
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
        <span
          className={`swap-btn`}
          style={{
            transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
          }}
          onClick={() => {
            const departure = multiFlight.departure;
            const arrival = multiFlight.arrival;
            const updated = [...multiCity];
            updated[index] = {
              ...updated[index],
              arrival: departure,
              departure: arrival,
            };
            setMultiCity(updated);
          }}
        >
          <SwapHorizIcon />
        </span>
      </div>

      <div className="date-wrapper">
        <div className="from-to-date-wrapper">
          <div className="from-date">
            <Menu
              shadow="md"
              opened={multiFlight.showDate}
              onChange={() => {
                const updated = [...multiCity];
                updated[index] = {
                  ...updated[index],
                  showDate: !multiFlight.showDate,
                };
                setMultiCity(updated);
              }}
            >
              <Menu.Target>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                    flex: 1,
                  }}
                >
                  <span className="date-icon-wrapper">
                    <DateRangeOutlinedIcon />
                  </span>
                  <span className="date-text" style={{ paddingRight: "10px" }}>
                    {formatDate(multiFlight.date)}
                  </span>{" "}
                </div>
              </Menu.Target>
              <Menu.Dropdown>
                <div
                  className="flight-input-dropdown"
                  style={{ width: "fit-content" }}
                >
                  <DatePicker
                    value={multiFlight.date}
                    onChange={(setDate) => {
                      const updated = [...multiCity];
                      updated[index] = {
                        ...updated[index],
                        date: setDate,
                        showDate: false,
                      };
                      setMultiCity(updated);
                    }}
                  />
                </div>
              </Menu.Dropdown>
            </Menu>
            <div className="date-btn-wrapper">
              <span
                onClick={() =>
                  handleMultiCityDateAction(index, multiFlight.date, "minus")
                }
              >
                <ArrowBackIosOutlinedIcon fontSize="13px" />
              </span>
              <span
                onClick={() =>
                  handleMultiCityDateAction(index, multiFlight.date, "add")
                }
              >
                <ArrowForwardIosOutlinedIcon fontSize="13px" />
              </span>
            </div>
          </div>
        </div>
      </div>

      {multiCity.length > 1 && (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            const updated = multiCity.filter((_, i) => i !== index);
            setMultiCity(updated);
          }}
        >
          <ClearIcon />
        </span>
      )}
    </div>
  );
};

const NewFlightSearch = () => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [showDetails, setShowDetails] = useState(false);
  const [flightDetailsData, setFlightDetailsData] = useState([]);

  const [allFilterOpen, setAllFilterOpen] = useState(false);
  const [shouldSearch, setShouldSearch] = useState(false);

  const [tripType, setTripType] = useState("one-way");
  const [previousFlight, setPreviousFlight] = useState(null);
  const [flightClassType, setFlightClassType] = useState("Economy");

  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [InfantsInSeat, setInfantsInSeat] = useState(0);
  const [InfantsOnLap, setInfantsOnLap] = useState(0);

  const [defaultOptions, setDefaultOptions] = useState([]);

  const [fromAirport, setFromAirport] = useState(null);
  const [toAirport, setToAirport] = useState(null);
  const [showFromAirport, setShowFromAirport] = useState(false);
  const [showToAirport, setShowToAirport] = useState(false);
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const formattedToday = `${yyyy}-${mm}-${dd}`;
  const [departureDate, setDepartureDate] = useState(formattedToday);
  const [returnDate, setReturnDate] = useState(formattedToday);
  const [showDepartureDate, setShowDepartureDate] = useState(false);
  const [showReturnDate, setShowReturnDate] = useState(false);
  const [rotation, setRotation] = useState(0);

  const [departureTime, setDepartureTime] = useState([0, 24]);
  const [arrivalTime, setArrivalTime] = useState([0, 24]);
  const [airlines, setAirlines] = useState([]);
  const [layoverStops, setLayoverStops] = useState([]);
  const [multiCity, setMultiCity] = useState([
    {
      departure: {},
      arrival: {},
      date: formattedToday,
      showDate: false,
      showDeparture: false,
      showArrival: false,
    },

    {
      departure: {},
      arrival: {},
      date: formattedToday,
      showDate: false,
      showDeparture: false,
      showArrival: false,
    },
  ]);

  const [selectedMultiCityFlights, setSelectedMultiCityFlights] = useState([]);
  const [stops, setStops] = useState("any");
  const [time, setTime] = useState("any");
  const [bags, setBags] = useState(0);
  const [price, setPrice] = useState(99999);
  const [duration, setDuration] = useState(45);
  const [currency, setCurrency] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [shortType, setShortType] = useState(1);

  const [checkedAirline, setCheckedAirline] = useState(true);
  const [checkedAirport, setCheckedAirport] = useState(true);

  useEffect(() => {
    setReturnFlights([]);
    setMultiCityFlights([]);
  }, [tripType]);

  useEffect(() => {
    if (isMobile) {
      setRotation(90);
    }
  }, [isMobile]);
  const [filters, setFilters] = useState([
    {
      filterLabel: "Stops",
      filterValue: null,
      key: "stops",
    },

    {
      filterLabel: "Bags",
      filterValue: null,
      key: "bags",
    },

    {
      filterLabel: "Price",
      filterValue: null,
      key: "price",
    },

    {
      filterLabel: "Times",
      filterValue: null,
      key: "times",
    },

    {
      filterLabel: "Duration",
      filterValue: null,
      key: "duration",
    },
    {
      filterLabel: "Currency",
      filterValue: null,
      key: "currency",
    },
    {
      filterLabel: "Airlines",
      filterValue: null,
      key: "airlines",
    },

    {
      filterLabel: "Connecting airports",
      filterValue: null,
      key: "airports",
    },
  ]);

  const handleMinus = (type) => {
    if (type === "adults") {
      setAdults((prev) => prev - 1);
    }

    if (type === "children") {
      setChildren((prev) => prev - 1);
    }

    if (type === "InfantsInSeat") {
      setInfantsInSeat((prev) => prev - 1);
    }

    if (type === "InfantsOnLap") {
      setInfantsOnLap((prev) => prev - 1);
    }
  };

  const handlePlus = (type) => {
    if (type === "adults") {
      setAdults((prev) => prev + 1);
    }

    if (type === "children") {
      setChildren((prev) => prev + 1);
    }

    if (type === "InfantsInSeat") {
      setInfantsInSeat((prev) => prev + 1);
    }

    if (type === "InfantsOnLap") {
      setInfantsOnLap((prev) => prev + 1);
    }
  };

  const debouncedLoadOptions = useMemo(
    () =>
      debounce((value, callback) => {
        loadOptions(value, callback);
      }, 200),
    []
  );

  const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

  const handleDateAction = (dateStr, type, instuction) => {
    const dateString = dateStr;
    const date = new Date(dateString);
    if (instuction === "add") {
      date.setDate(date.getDate() + 1);
    } else {
      date.setDate(date.getDate() - 1);
    }

    const newDate = date.toISOString().split("T")[0];

    if (type === "departure") {
      setDepartureDate(newDate);
    } else if (type === "return") {
      setReturnDate(newDate);
    }
  };

  useEffect(() => {
    if (shouldSearch) {
      handleSearch();
    }
  }, [shouldSearch]);

  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (previousFlight || selectedMultiCityFlights.length > 0) {
      // setPreviousFlight(null);
      // setSelectedMultiCityFlights([])

      setDismissed(true);
    }
  }, [toAirport, fromAirport, departureDate, returnDate, multiCity]);

  const handleMultiCityDateAction = (index, dateStr, instuction) => {
    const dateString = dateStr;
    const date = new Date(dateString);
    if (instuction === "add") {
      date.setDate(date.getDate() + 1);
    } else {
      date.setDate(date.getDate() - 1);
    }

    const newDate = date.toISOString().split("T")[0];

    const updated = [...multiCity];
    updated[index] = {
      ...updated[index],
      date: newDate,
    };
    setMultiCity(updated);
  };

  const handleExchange = (e) => {
    setRotation((prev) => prev + 180);
    const temp = fromAirport;
    setFromAirport(toAirport);
    setToAirport(temp);
  };

  const [flights, setFlights] = useState([]);
  const [bestFlights, setBestFlights] = useState([]);
  const [otherFlights, setOtherFlights] = useState([]);
  const [returnFlights, setReturnFlights] = useState([]);
  const [multiCityFlights, setMultiCityFlights] = useState([]);

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    return new Date(date).toLocaleDateString("en-GB", options);
  };

  const [loading, setLoading] = useState(false);

  const handleSortChange = (value) => {
    setShortType(value);
  };

  useEffect(() => {
    if (
      bestFlights.length > 0 ||
      otherFlights.length > 0 ||
      returnFlights.length > 0 ||
      multiCityFlights.length > 0
    ) {
      handleSearch();
    }
  }, [shortType]);

  useEffect(() => {
    if (previousFlight) {
      setOtherFlights([]);
      setBestFlights([]);
      handleSearch();
    }
  }, [previousFlight]);

  useEffect(() => {
    if (selectedMultiCityFlights.length > 0) {
      setOtherFlights([]);
      setBestFlights([]);
      setReturnFlights([]);

      handleSearch();
    }
  }, [selectedMultiCityFlights]);

  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    if (hasChanged && (bestFlights.length > 0 || otherFlights.length > 0)) {
      const mergedFlights = [...bestFlights, ...otherFlights];

      const allAirlines = Array.from(
        new Map(
          mergedFlights
            .flatMap((flightGroup) =>
              flightGroup.flights.map((f) => ({
                name: f.airline,
                code: f.flight_number.split(" ")[0],
                selected: true,
              }))
            )
            .map((item) => [item.name, item])
        ).values()
      );

      const allLayovers = mergedFlights.flatMap(
        (flight) => flight.layovers || []
      );

      const uniqueLayoversByName = Array.from(
        new Map(allLayovers.map((layover) => [layover.name, layover])).values()
      );

      const layoverObject = uniqueLayoversByName.map((layover) => ({
        ...layover,
        selected: true,
      }));

      console.log(allAirlines);
      setAirlines(allAirlines);
      setLayoverStops(layoverObject);

      // if (allAirlines.length > 0) {
      //   setFilters((prevFilters) => {
      //     const alreadyExists = prevFilters.some(
      //       (filter) => filter.key === "airlines"
      //     );

      //     if (alreadyExists) return prevFilters;

      //     return [
      //       ...prevFilters,
      //       {
      //         filterLabel: "Airlines",
      //         filterValue: null,
      //         key: "airlines",
      //       },
      //     ];
      //   });
      // }

      // if (uniqueLayoversByName.length > 0) {
      //   setFilters((prevFilters) => {
      //     const alreadyExists = prevFilters.some(
      //       (filter) => filter.key === "airports"
      //     );

      //     if (alreadyExists) return prevFilters;

      //     return [
      //       ...prevFilters,
      //       {
      //         filterLabel: "Connecting airports",
      //         filterValue: null,
      //         key: "airports",
      //       },
      //     ];
      //   });
      // }
    }
  }, [hasChanged]);

  useEffect(() => {
    setHasChanged(false);
  }, [toAirport, fromAirport]);

  const handleSearch = async () => {
    let multyCityEmpty = false;
    let normalTripTypeEmpty = false;
    if (tripType === "multi-city") {
      multyCityEmpty = multiCity.some((city) => {
        return (
          !city.departure ||
          Object.keys(city.departure).length === 0 ||
          !city.arrival ||
          Object.keys(city.arrival).length === 0
        );
      });
    } else {
      if (!fromAirport || !toAirport || !departureDate) {
        normalTripTypeEmpty = true;
      }
    }

    if (multyCityEmpty) {
      return;
    }

    if (normalTripTypeEmpty) {
      return;
    }

    console.log(multiCity);
    setLoading(true);
    setReturnFlights([]);
    setMultiCityFlights([]);
    const requestData = {
      engine: "google_flights",

      currency: currency ? currency.code : "USD",
      adults: adults,
      children: children,
      infants_in_seat: InfantsInSeat,
      infants_on_lap: InfantsOnLap,
      sort_by: shortType,

      travel_class:
        flightClassType === "Economy"
          ? 1
          : flightClassType === "Premium economy"
          ? 2
          : flightClassType === "Business"
          ? 3
          : flightClassType === "First"
          ? 4
          : null,
    };

    if (tripType === "one-way" || tripType === "round-trip") {
      requestData.departure_id = fromAirport.iata;
      requestData.arrival_id = toAirport.iata;
      requestData.outbound_date = departureDate;
    }
    if (tripType === "round-trip") {
      requestData.return_date = returnDate;
    }

    if (tripType === "multi-city") {
      requestData.type = 3;
      const simplified = multiCity.map((flight) => ({
        departure_id: flight.departure?.iata || "",
        arrival_id: flight.arrival?.iata || "",
        date: flight.date,
      }));

      console.log(JSON.stringify(simplified));

      requestData.multi_city_json = simplified;
    }

    if (stops !== "any") {
      requestData.stops = Number(stops);
    }

    if (
      departureTime[0] !== 0 ||
      departureTime[1] !== 24 ||
      arrivalTime[0] !== 0 ||
      arrivalTime[1] !== 24
    ) {
      if (arrivalTime[0] !== 0 || arrivalTime[1] !== 24) {
        requestData.outbound_times = [
          departureTime[0],
          departureTime[1] - 1,
          arrivalTime[0],
          arrivalTime[1] - 1,
        ].join(",");
      } else {
        requestData.outbound_times = [
          departureTime[0],
          departureTime[1] - 1,
        ].join(",");
      }
    }

    if (bags !== 0) {
      requestData.bags = Number(bags) - 1;
    }

    if (price < 99999) {
      requestData.max_price = Number(price);
    }

    if (time !== "any") {
      requestData.outbound_times = time;
    }

    if (duration < 45) {
      requestData.max_duration = Number(duration) * 60;
    }

    const falseAirport = layoverStops.filter((a) => a.selected === false);

    if (falseAirport.length > 0) {
      const exclude = falseAirport.map((airport) => {
        console.log("Original ID:", airport.id); // check type
        const upper = String(airport.id).toUpperCase();
        console.log("Uppercase ID:", upper);
        return upper;
      });

      console.log("Exlude Cons", exclude);

      requestData.exclude_conns = exclude.toString();
    }

    const falseAirlines = airlines.filter((a) => a.selected === false);

    if (falseAirlines.length > 0) {
      const exclude = falseAirlines.map((airport) => {
        return airport.code;
      });

      console.log("Exlude Cons", exclude);

      requestData.exclude_airlines = exclude.join(",");
    }

    if (dismissed) {
      setPreviousFlight(null);
      setSelectedMultiCityFlights([]);
    }

    if (previousFlight && !dismissed) {
      console.log("Passing");
      console.log("Previous FLight===============> ", previousFlight);
      requestData.departure_token = previousFlight.departure_token;
    }

    if (selectedMultiCityFlights.length > 0 && !dismissed) {
      requestData.departure_token =
        selectedMultiCityFlights.at(-1).departure_token;
    }

    try {
      const response = await axios.post(
        `${base_url.api1}/users/flight_search`,
        requestData
      );
      console.log(response.data);

      setCurrencySymbol(currency ? currency.symbol : "$");
      if (previousFlight && !dismissed) {
        const othersReturnFlights = response.data.data.other_flights || [];
        const bestReturnFlights = response.data.data.best_flights || [];
        const returnFlights = [...bestReturnFlights, ...othersReturnFlights];
        setReturnFlights(returnFlights);
      } else if (selectedMultiCityFlights.length > 0 && !dismissed) {
        const othersMultiFlights = response.data.data.other_flights || [];
        const bestMultiFlights = response.data.data.best_flights || [];
        const multiFlights = [...bestMultiFlights, ...othersMultiFlights];
        setMultiCityFlights(multiFlights);
      } else {
        setBestFlights(response.data.data.best_flights || []);
        setOtherFlights(response.data.data.other_flights || []);
        setDismissed(false);
      }

      setHasChanged(true);
      setLoading(false);
      setShouldSearch(false);
    } catch (error) {
      setBestFlights([]);
      setOtherFlights([]);
      console.error("Error searching flights:", error);
      setLoading(false);
      setShouldSearch(false);
    }
  };

  const clearFilters = () => {
    setStops("any");
    setBags(0);
    setPrice(99999);
    setDepartureTime([0, 24]);
    setArrivalTime([0, 24]);
    setDuration(45);
    const airportObject = layoverStops.map((stop) => ({
      ...stop,
      selected: true,
    }));
    setLayoverStops(airportObject);
    const airlineObject = airlines.map((airline) => ({
      ...airline,
      selected: true,
    }));

    console.log("Airline Object========> ", airlineObject);
    setAirlines(airlineObject);

    setCurrency(null);

    setFilters((prev) =>
      prev.map((f) => {
        return { ...f, filterValue: null };
      })
    );

    setAllFilterOpen(false);
  };
  const fetchAirports = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/airport_list?search=${inputValue}&sortby=airport_name`
        );
        if (response.data && response.data.Airports) {
          return response.data.Airports.map((airport) => ({
            name: airport.name,
            shortName: airport.shortName,
            municipalityName: airport.municipalityName,
            iata: airport.iata,
          }));
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }
    return [];
  };

  const [initialAirports, setInitialAirports] = useState([]);
  const fetchInitialAirports = async () => {
    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/airport_list?search=new`
      );
      if (response.data && response.data.Airports) {
        console.log("Airposrts ===========> ", response.data.Airports);
        const options = response.data.Airports.map((airport) => ({
          name: airport.name,
          shortName: airport.shortName,
          municipalityName: airport.municipalityName,
          iata: airport.iata,
        }));
        setInitialAirports(options);
        setDefaultOptions(options);
      }
    } catch (error) {
      console.error("Error fetching initial airports:", error);
    }
  };

  useEffect(() => {
    fetchInitialAirports();
  }, []);

  const handleCloseToAirport = () => {
    setShowToAirport(false);
    setDefaultOptions(initialAirports);
  };

  const handleCloseFromAirport = () => {
    setShowFromAirport(false);
    setDefaultOptions(initialAirports);
  };

  const handleMultiCloseToAirport = (i) => {
    setShowToAirport(false);
    setDefaultOptions(initialAirports);
  };

  const handleMultiCloseFromAirport = () => {
    setShowFromAirport(false);
    setDefaultOptions(initialAirports);
  };

  const wrapperRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  const updateButtonVisibility = () => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const isOverflowing = wrapper.scrollWidth > wrapper.clientWidth;

    setShowLeft(wrapper.scrollLeft > 0 && isOverflowing);
    setShowRight(
      wrapper.scrollLeft + wrapper.clientWidth < wrapper.scrollWidth &&
        isOverflowing
    );
  };

  const scrollToStart = () => {
    wrapperRef.current?.scrollTo({ left: 0, behavior: "smooth" });
  };

  const scrollToEnd = () => {
    wrapperRef.current?.scrollTo({
      left: wrapperRef.current.scrollWidth,
      behavior: "smooth",
    });
  };

  const updateFilterValue = (key, value) => {
    setFilters((prevFilters) =>
      prevFilters.map((filter) =>
        filter.key === key ? { ...filter, filterValue: value } : filter
      )
    );
  };

  useEffect(() => {
    if (stops === "1") {
      updateFilterValue("stops", "Nonstop");
    } else if (stops === "2") {
      updateFilterValue("stops", "1 stop or fewer");
    } else if (stops === "3") {
      updateFilterValue("stops", "2 stop or fewer");
    } else {
      updateFilterValue("stops", null);
    }

    if (bags === 1) {
      updateFilterValue("bags", "1 carry-on bag");
    } else if (bags === 2) {
      updateFilterValue("bags", "2 carry-on bag");
    } else {
      updateFilterValue("bags", null);
    }

    if (price < 99999) {
      updateFilterValue("price", "up to " + price);
    } else {
      updateFilterValue("price", null);
    }

    if (
      departureTime[0] !== 0 ||
      departureTime[1] !== 24 ||
      arrivalTime[0] !== 0 ||
      arrivalTime[1] !== 24
    ) {
      updateFilterValue("times", "Times");
    } else {
      updateFilterValue("times", null);
    }

    if (duration < 45) {
      updateFilterValue("duration", "under " + duration + " hr");
    } else {
      updateFilterValue("duration", null);
    }

    const falseCount = airlines.filter((a) => a.selected === false).length;
    if (falseCount > 0) {
      updateFilterValue("airlines", "Exclude airline " + falseCount);
    } else {
      updateFilterValue("airlines", null);
    }

    const falseAirportCount = layoverStops.filter(
      (a) => a.selected === false
    ).length;
    if (falseAirportCount > 0) {
      updateFilterValue("airports", "Exclude airports " + falseAirportCount);
    } else {
      updateFilterValue("airports", null);
    }

    if (currency !== null) {
      updateFilterValue("currency", currency.code);
    } else {
      updateFilterValue("currency", null);
    }
  }, [
    bags,
    price,
    stops,
    departureTime,
    arrivalTime,
    duration,
    layoverStops,
    airlines,
    currency,
  ]);

  useEffect(() => {
    updateButtonVisibility();
    const wrapper = wrapperRef.current;

    if (!wrapper) return;

    wrapper.addEventListener("scroll", updateButtonVisibility);
    window.addEventListener("resize", updateButtonVisibility);

    return () => {
      wrapper.removeEventListener("scroll", updateButtonVisibility);
      window.removeEventListener("resize", updateButtonVisibility);
    };
  }, [filters]);

  const fromDropdownRef = useRef(null);
  const toDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        fromDropdownRef.current &&
        !fromDropdownRef.current.contains(event.target)
      ) {
        setShowFromAirport(false);
      }

      if (
        toDropdownRef.current &&
        !toDropdownRef.current.contains(event.target)
      ) {
        setShowToAirport(false);
      }
    };

    if (showFromAirport) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    if (showToAirport) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFromAirport, showToAirport]);

  return (
    <div>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Nav />

        {showDetails ? (
          <FlightDetails
            flightDetailsData={flightDetailsData}
            fromAirport={fromAirport}
            toAirport={toAirport}
            flightClassType={flightClassType}
            tripType={tripType}
            adults={adults}
            children={children}
            InfantsInSeat={InfantsInSeat}
            InfantsOnLap={InfantsOnLap}
            setPreviousFlight={setPreviousFlight}
            setSelectedMultiCityFlights={setSelectedMultiCityFlights}
            setFlightDetailsData={setFlightDetailsData}
            setShowDetails={setShowDetails}
            handleMinus={handleMinus}
            handlePlus={handlePlus}
          />
        ) : (
          <div className="flight_search_wrapper">
            <div className="flight-container">
              <div className="trip_section">
                <Menu shadow="md" position="bottom-start" offset={2}>
                  <Menu.Target>
                    <span className="trip_wrapper">
                      <span className="trip_icon_wrapper">
                        {tripType === "one-way" ? (
                          <>
                            {" "}
                            <ArrowRightAltIcon /> One way
                          </>
                        ) : tripType === "round-trip" ? (
                          <>
                            {" "}
                            <SwapHorizIcon /> Round trip
                          </>
                        ) : tripType === "multi-city" ? (
                          <>
                            {" "}
                            <MultipleStopIcon /> Multi-city
                          </>
                        ) : null}
                      </span>

                      <ArrowDropDownIcon />
                    </span>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item
                      leftSection={<ArrowRightAltIcon />}
                      onClick={() => {
                        setMultiCity([
                          {
                            departure: {},
                            arrival: {},
                            date: formattedToday,
                            showDate: false,
                            showDeparture: false,
                            showArrival: false,
                          },

                          {
                            departure: {},
                            arrival: {},
                            date: formattedToday,
                            showDate: false,
                            showDeparture: false,
                            showArrival: false,
                          },
                        ]);
                        setTripType("one-way");
                      }}
                    >
                      One way
                    </Menu.Item>
                    <Menu.Item
                      leftSection={<SwapHorizIcon />}
                      onClick={() => {
                        setMultiCity([
                          {
                            departure: {},
                            arrival: {},
                            date: formattedToday,
                            showDate: false,
                            showDeparture: false,
                            showArrival: false,
                          },

                          {
                            departure: {},
                            arrival: {},
                            date: formattedToday,
                            showDate: false,
                            showDeparture: false,
                            showArrival: false,
                          },
                        ]);
                        setTripType("round-trip");
                      }}
                    >
                      Round trip
                    </Menu.Item>

                    <Menu.Item
                      leftSection={<MultipleStopIcon />}
                      onClick={() => {
                        setFromAirport(null);
                        setToAirport(null);
                        setTripType("multi-city");
                      }}
                    >
                      Multi city
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>

                <Menu
                  shadow="md"
                  position="bottom-start"
                  offset={2}
                  width={250}
                >
                  <Menu.Target>
                    <span className="trip_wrapper">
                      <span className="trip_icon_wrapper">
                        <PersonOutlineIcon />{" "}
                        {adults + children + InfantsInSeat + InfantsOnLap}
                      </span>

                      <ArrowDropDownIcon />
                    </span>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <div className="person-wrapper">
                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Adults</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={adults === 1}
                            style={{ opacity: adults === 1 ? 0.6 : 1 }}
                            onClick={() => handleMinus("adults")}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{adults}</span>
                          <button
                            className="count-btn"
                            onClick={() => handlePlus("adults")}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>

                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Children</span>
                          <span className="person-sub">Aged 2-11</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={children === 0}
                            style={{ opacity: children === 0 ? 0.6 : 1 }}
                            onClick={() => handleMinus("children")}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{children}</span>
                          <button
                            className="count-btn"
                            onClick={() => handlePlus("children")}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>

                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Infants</span>
                          <span className="person-sub">In seat</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={InfantsInSeat === 0}
                            style={{ opacity: InfantsInSeat === 0 ? 0.6 : 1 }}
                            onClick={() => handleMinus("InfantsInSeat")}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{InfantsInSeat}</span>
                          <button
                            className="count-btn"
                            onClick={() => handlePlus("InfantsInSeat")}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>

                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Infants</span>
                          <span className="person-sub">On lap</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={InfantsOnLap === 0}
                            style={{ opacity: InfantsOnLap === 0 ? 0.6 : 1 }}
                            onClick={() => handleMinus("InfantsOnLap")}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{InfantsOnLap}</span>
                          <button
                            className="count-btn"
                            onClick={() => handlePlus("InfantsOnLap")}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </Menu.Dropdown>
                </Menu>

                <Menu shadow="md" position="bottom-start" offset={2}>
                  <Menu.Target>
                    <span className="trip_wrapper ">
                      <span className="trip_icon_wrapper mobile-trip-icon-wrapper">
                        {flightClassType}
                      </span>

                      <ArrowDropDownIcon />
                    </span>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item onClick={() => setFlightClassType("Economy")}>
                      Economy
                    </Menu.Item>
                    <Menu.Item
                      onClick={() => setFlightClassType("Premium economy")}
                    >
                      Premium economy
                    </Menu.Item>

                    <Menu.Item onClick={() => setFlightClassType("Business")}>
                      Business
                    </Menu.Item>

                    <Menu.Item onClick={() => setFlightClassType("First")}>
                      First
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </div>

              {tripType !== "multi-city" && (
                <div className="search_section">
                  <div className="place-wrapper">
                    {/* <Menu
                    shadow="md"
                    position="bottom-start"
                    offset={2}
                    width={400}
                    opened={showFromAirport}
                    onChange={setShowFromAirport}
                  >
                    <Menu.Target>
                      <div className="from-place">
                        <AdjustIcon />
                        <div className="flight-place-name">
                          {fromAirport?.name || "Select Airport"}
                        </div>
                      </div>
                    </Menu.Target>

                    <Menu.Dropdown>
                      <div>
                        <div className="search-input-wrapper">
                          <span>
                            <AdjustIcon />
                          </span>
                          <input
                            type="text"
                            placeholder="Where from?"
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length === 0) {
                                setDefaultOptions(initialAirports);
                                return;
                              }
                              debouncedLoadOptions(inputValue, (options) => {
                                setDefaultOptions(options);
                              });
                            }}
                          />
                        </div>
                        <div className="search-flight-list">
                          {defaultOptions.length > 0 ? (
                            defaultOptions.map((option, index) => (
                              <span
                                className="flight-dropdown-item"
                                key={index}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  console.log(option);
                                  setFromAirport(option);
                                  handleCloseFromAirport();
                                }}
                              >
                                <AirplanemodeActiveOutlinedIcon />
                                {option.name}{" "}
                                <span className="iata_code">
                                  ({option.iata})
                                </span>
                              </span>
                            ))
                          ) : (
                            <span
                              style={{
                                padding: "10px",
                                display: "block",
                                textAlign: "center",
                              }}
                            >
                              No matching locations found
                            </span>
                          )}
                        </div>
                      </div>
                    </Menu.Dropdown>
                  </Menu> */}

                    <div
                      className="from-place"
                      ref={fromDropdownRef}
                      onClick={() => setShowFromAirport(true)}
                    >
                      <AdjustIcon />
                      <div className="flight-place-name">
                        {fromAirport?.name || "Select Airport"}
                      </div>
                      {showFromAirport && (
                        <div className="airport-dropdown">
                          <div className="search-input-wrapper">
                            <span>
                              <AdjustIcon />
                            </span>
                            <input
                              type="text"
                              placeholder="Where from?"
                              autoFocus
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length === 0) {
                                  setDefaultOptions(initialAirports);
                                  return;
                                }
                                debouncedLoadOptions(inputValue, (options) => {
                                  setDefaultOptions(options);
                                });
                              }}
                            />
                          </div>
                          <div className="search-flight-list">
                            {defaultOptions.length > 0 ? (
                              defaultOptions.map((option, index) => (
                                <span
                                  className="flight-dropdown-item"
                                  key={index}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    console.log(option);
                                    setFromAirport(option);
                                    handleCloseFromAirport();
                                  }}
                                >
                                  <AirplanemodeActiveOutlinedIcon />
                                  {option.name}{" "}
                                  <span className="iata_code">
                                    ({option.iata})
                                  </span>
                                </span>
                              ))
                            ) : (
                              <span
                                style={{
                                  padding: "10px",
                                  display: "block",
                                  textAlign: "center",
                                }}
                              >
                                No matching locations found
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div
                      className="from-place"
                      onClick={() => setShowToAirport(true)}
                      ref={toDropdownRef}
                    >
                      <LocationOnOutlinedIcon />
                      <div className="flight-place-name">
                        {toAirport?.name || "Select Airport"}
                      </div>

                      {showToAirport && (
                        <div className="airport-dropdown">
                          <div className="search-input-wrapper">
                            <span>
                              <LocationOnOutlinedIcon />
                            </span>
                            <input
                              type="text"
                              placeholder="Where to?"
                              autoFocus
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length === 0) {
                                  setDefaultOptions(initialAirports);
                                  return;
                                }
                                debouncedLoadOptions(inputValue, (options) => {
                                  setDefaultOptions(options);
                                });
                              }}
                            />
                          </div>
                          <div className="search-flight-list">
                            {defaultOptions.length > 0 ? (
                              defaultOptions.map((option, index) => (
                                <span
                                  className="flight-dropdown-item"
                                  key={index}
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    setToAirport(option);
                                    handleCloseToAirport();
                                  }}
                                >
                                  <AirplanemodeActiveOutlinedIcon />
                                  {option.name}{" "}
                                  <span className="iata_code">
                                    ({option.iata})
                                  </span>
                                </span>
                              ))
                            ) : (
                              <span
                                style={{
                                  padding: "10px",
                                  display: "block",
                                  textAlign: "center",
                                }}
                              >
                                No matching locations found
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* <Menu
                    shadow="md"
                    position="bottom-start"
                    offset={2}
                    width={400}
                    opened={showToAirport}
                    onChange={setShowToAirport}
                  >
                    <Menu.Target>
                      <div className="from-place">
                        <LocationOnOutlinedIcon />
                        <div className="flight-place-name">
                          {toAirport?.name || "Select Airport"}
                        </div>
                      </div>
                    </Menu.Target>

                    <Menu.Dropdown>
                      <div>
                        <div className="search-input-wrapper">
                          <span>
                            <LocationOnOutlinedIcon />
                          </span>
                          <input
                            type="text"
                            placeholder="Where to?"
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length === 0) {
                                setDefaultOptions(initialAirports);
                                return;
                              }
                              debouncedLoadOptions(inputValue, (options) => {
                                setDefaultOptions(options);
                              });
                            }}
                          />
                        </div>
                        <div className="search-flight-list">
                          {defaultOptions.length > 0 ? (
                            defaultOptions.map((option, index) => (
                              <span
                                className="flight-dropdown-item"
                                key={index}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  setToAirport(option);
                                  handleCloseToAirport();
                                }}
                              >
                                <AirplanemodeActiveOutlinedIcon />
                                {option.name}{" "}
                                <span className="iata_code">
                                  ({option.iata})
                                </span>
                              </span>
                            ))
                          ) : (
                            <span
                              style={{
                                padding: "10px",
                                display: "block",
                                textAlign: "center",
                              }}
                            >
                              No matching locations found
                            </span>
                          )}
                        </div>
                      </div>
                    </Menu.Dropdown>
                  </Menu> */}

                    <span
                      className={`swap-btn`}
                      style={{
                        transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
                      }}
                      onClick={handleExchange}
                    >
                      <SwapHorizIcon />
                    </span>
                  </div>

                  <div className="date-wrapper">
                    <div className="from-to-date-wrapper">
                      <div className="from-date">
                        <Menu
                          shadow="md"
                          opened={showDepartureDate}
                          onChange={setShowDepartureDate}
                        >
                          <Menu.Target>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "stretch",
                                flex: 1,
                              }}
                            >
                              <span className="date-icon-wrapper">
                                <DateRangeOutlinedIcon />
                              </span>
                              <span
                                className="date-text"
                                style={{ paddingRight: "10px" }}
                              >
                                {formatDate(departureDate)}
                              </span>{" "}
                            </div>
                          </Menu.Target>
                          <Menu.Dropdown>
                            <div
                              className="flight-input-dropdown"
                              style={{ width: "fit-content" }}
                            >
                              <DatePicker
                                value={departureDate}
                                onChange={(setDate) => {
                                  setDepartureDate(setDate);
                                  setShowDepartureDate(false);
                                }}
                              />
                            </div>
                          </Menu.Dropdown>
                        </Menu>
                        <div className="date-btn-wrapper">
                          <span
                            onClick={() =>
                              handleDateAction(
                                departureDate,
                                "departure",
                                "minus"
                              )
                            }
                          >
                            <ArrowBackIosOutlinedIcon fontSize="13px" />
                          </span>
                          <span
                            onClick={() =>
                              handleDateAction(
                                departureDate,
                                "departure",
                                "add"
                              )
                            }
                          >
                            <ArrowForwardIosOutlinedIcon fontSize="13px" />
                          </span>
                        </div>
                      </div>
                      {tripType === "round-trip" && (
                        <div className="from-date">
                          <Menu
                            shadow="md"
                            opened={showReturnDate}
                            onChange={setShowReturnDate}
                            disabled={tripType === "one-way" ? true : false}
                          >
                            <Menu.Target>
                              <span className="date-text">
                                {formatDate(returnDate)}
                              </span>
                            </Menu.Target>
                            <Menu.Dropdown>
                              <div
                                className="flight-input-dropdown"
                                style={{ width: "fit-content" }}
                              >
                                <DatePicker
                                  value={returnDate}
                                  minDate={departureDate}
                                  onChange={(setDate) => {
                                    setReturnDate(setDate);
                                    setShowReturnDate(false);
                                  }}
                                  placeholder="Select return date"
                                />
                              </div>
                            </Menu.Dropdown>
                          </Menu>
                          <div className="date-btn-wrapper">
                            <span
                              onClick={() =>
                                handleDateAction(returnDate, "return", "minus")
                              }
                            >
                              <ArrowBackIosOutlinedIcon fontSize="13px" />
                            </span>
                            <span
                              onClick={() =>
                                handleDateAction(returnDate, "return", "add")
                              }
                            >
                              <ArrowForwardIosOutlinedIcon fontSize="13px" />
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {tripType === "multi-city" && (
                <>
                  {multiCity.map((multiFlight, index) => {
                    return (
                      <MultiCityItem
                        key={index}
                        multiFlight={multiFlight}
                        index={index}
                        multiCity={multiCity}
                        setMultiCity={setMultiCity}
                        defaultOptions={defaultOptions}
                        setDefaultOptions={setDefaultOptions}
                        initialAirports={initialAirports}
                        debouncedLoadOptions={debouncedLoadOptions}
                        handleMultiCityDateAction={handleMultiCityDateAction}
                        formatDate={formatDate}
                        rotation={rotation}
                      />
                    );

                    //                return (
                    //                     <div className="search_section" key={index}>
                    //                       <div className="place-wrapper">
                    //                         {/* <Menu
                    //                           shadow="md"
                    //                           position="bottom-start"
                    //                           offset={2}
                    //                           width={400}
                    //                           opened={multiFlight.showDeparture}
                    //                           onChange={() => {
                    //                             const updated = [...multiCity];
                    //                             updated[index] = {
                    //                               ...updated[index],
                    //                               showDeparture: !multiFlight.showDeparture,
                    //                             };
                    //                             setMultiCity(updated);
                    //                             setDefaultOptions(initialAirports);
                    //                           }}
                    //                         >
                    //                           <Menu.Target>
                    //                             <div className="from-place">
                    //                               <AdjustIcon />
                    //                               <div className="flight-place-name">
                    //                                 {multiFlight?.departure?.name ||
                    //                                   "Select Airport"}
                    //                               </div>
                    //                             </div>
                    //                           </Menu.Target>

                    //                           <Menu.Dropdown>
                    //                             <div>
                    //                               <div className="search-input-wrapper">
                    //                                 <span>
                    //                                   <AdjustIcon />
                    //                                 </span>
                    //                                 <input
                    //                                   type="text"
                    //                                   placeholder="Where from?"
                    //                                   onChange={(e) => {
                    //                                     const inputValue = e.target.value;
                    //                                     if (inputValue.length === 0) {
                    //                                       setDefaultOptions(initialAirports);
                    //                                       return;
                    //                                     }
                    //                                     debouncedLoadOptions(
                    //                                       inputValue,
                    //                                       (options) => {
                    //                                         setDefaultOptions(options);
                    //                                       }
                    //                                     );
                    //                                   }}
                    //                                 />
                    //                               </div>
                    //                               <div className="search-flight-list">
                    //                                 {defaultOptions.length > 0 ? (
                    //                                   defaultOptions.map((option, i) => (
                    //                                     <span
                    //                                       className="flight-dropdown-item"
                    //                                       key={i}
                    //                                       onClick={(e) => {
                    //                                         e.stopPropagation();
                    //                                         console.log(option);

                    //                                         const updated = [...multiCity];
                    //                                         updated[index] = {
                    //                                           ...updated[index],
                    //                                           departure: option,
                    //                                           showDeparture: false,
                    //                                         };
                    //                                         setMultiCity(updated);
                    //                                       }}
                    //                                     >
                    //                                       <AirplanemodeActiveOutlinedIcon />
                    //                                       {option.name}{" "}
                    //                                       <span className="iata_code">
                    //                                         ({option.iata})
                    //                                       </span>
                    //                                     </span>
                    //                                   ))
                    //                                 ) : (
                    //                                   <span
                    //                                     style={{
                    //                                       padding: "10px",
                    //                                       display: "block",
                    //                                       textAlign: "center",
                    //                                     }}
                    //                                   >
                    //                                     No matching locations found
                    //                                   </span>
                    //                                 )}
                    //                               </div>
                    //                             </div>
                    //                           </Menu.Dropdown>
                    //                         </Menu> */}

                    //                         <div className="from-place" onClick={() => {
                    //                            const updated = [...multiCity];
                    //                             updated[index] = {
                    //                               ...updated[index],
                    //                               showDeparture: true,
                    //                           };

                    //                           setMultiCity(updated)
                    //                           }}>
                    //                               <AdjustIcon />
                    //                               <div className="flight-place-name">
                    //                                 {multiFlight?.departure?.name ||
                    //                                   "Select Airport"}
                    //                           </div>

                    //                           {
                    //                             multiFlight.showDeparture &&   <div className="airport-dropdown">
                    //                               <div className="search-input-wrapper">
                    //                                 <span>
                    //                                   <AdjustIcon />
                    //                                 </span>
                    //                                 <input
                    //                                   type="text"
                    //                                   placeholder="Where from?"
                    //                                   autoFocus
                    //                                   onChange={(e) => {
                    //                                     const inputValue = e.target.value;
                    //                                     if (inputValue.length === 0) {
                    //                                       setDefaultOptions(initialAirports);
                    //                                       return;
                    //                                     }
                    //                                     debouncedLoadOptions(
                    //                                       inputValue,
                    //                                       (options) => {
                    //                                         setDefaultOptions(options);
                    //                                       }
                    //                                     );
                    //                                   }}
                    //                                 />
                    //                               </div>
                    //                               <div className="search-flight-list">
                    //                                 {defaultOptions.length > 0 ? (
                    //                                   defaultOptions.map((option, i) => (
                    //                                     <span
                    //                                       className="flight-dropdown-item"
                    //                                       key={i}
                    //                                       onClick={(e) => {
                    //                                         e.stopPropagation();
                    //                                         console.log(option);

                    //                                         const updated = [...multiCity];
                    //                                         updated[index] = {
                    //                                           ...updated[index],
                    //                                           departure: option,
                    //                                           showDeparture: false,
                    //                                         };
                    //                                         setMultiCity(updated);
                    //                                       }}
                    //                                     >
                    //                                       <AirplanemodeActiveOutlinedIcon />
                    //                                       {option.name}{" "}
                    //                                       <span className="iata_code">
                    //                                         ({option.iata})
                    //                                       </span>
                    //                                     </span>
                    //                                   ))
                    //                                 ) : (
                    //                                   <span
                    //                                     style={{
                    //                                       padding: "10px",
                    //                                       display: "block",
                    //                                       textAlign: "center",
                    //                                     }}
                    //                                   >
                    //                                     No matching locations found
                    //                                   </span>
                    //                                 )}
                    //                               </div>
                    //                             </div>
                    // }

                    //                         </div>

                    //                          <div className="from-place" onClick={() => {
                    //                            const updated = [...multiCity];
                    //                             updated[index] = {
                    //                               ...updated[index],
                    //                               showArrival: true,
                    //                           };

                    //                           setMultiCity(updated)
                    //                           }}>
                    //                               <LocationOnOutlinedIcon />
                    //                               <div className="flight-place-name">
                    //                                 {multiFlight?.arrival?.name || "Select Airport"}
                    //                           </div>

                    //                           {
                    //                             multiFlight.showArrival && <div className="airport-dropdown">
                    //                               <div className="search-input-wrapper">
                    //                                 <span>
                    //                                   <LocationOnOutlinedIcon />
                    //                                 </span>
                    //                                 <input
                    //                                   type="text"
                    //                                   placeholder="Where to?"
                    //                                   autoFocus
                    //                                   onChange={(e) => {
                    //                                     const inputValue = e.target.value;
                    //                                     if (inputValue.length === 0) {
                    //                                       setDefaultOptions(initialAirports);
                    //                                       return;
                    //                                     }
                    //                                     debouncedLoadOptions(
                    //                                       inputValue,
                    //                                       (options) => {
                    //                                         setDefaultOptions(options);
                    //                                       }
                    //                                     );
                    //                                   }}
                    //                                 />
                    //                               </div>
                    //                               <div className="search-flight-list">
                    //                                 {defaultOptions.length > 0 ? (
                    //                                   defaultOptions.map((option, i) => (
                    //                                     <span
                    //                                       className="flight-dropdown-item"
                    //                                       key={i}
                    //                                       onClick={(e) => {
                    //                                         e.stopPropagation();

                    //                                         const updated = [...multiCity];
                    //                                         updated[index] = {
                    //                                           ...updated[index],
                    //                                           arrival: option,
                    //                                           showArrival: false,
                    //                                         };
                    //                                         setMultiCity(updated);
                    //                                       }}
                    //                                     >
                    //                                       <AirplanemodeActiveOutlinedIcon />
                    //                                       {option.name}{" "}
                    //                                       <span className="iata_code">
                    //                                         ({option.iata})
                    //                                       </span>
                    //                                     </span>
                    //                                   ))
                    //                                 ) : (
                    //                                   <span
                    //                                     style={{
                    //                                       padding: "10px",
                    //                                       display: "block",
                    //                                       textAlign: "center",
                    //                                     }}
                    //                                   >
                    //                                     No matching locations found
                    //                                   </span>
                    //                                 )}
                    //                               </div>
                    //                             </div>
                    // }

                    //                             </div>

                    //                         {/* <Menu
                    //                           shadow="md"
                    //                           position="bottom-start"
                    //                           offset={2}
                    //                           width={400}
                    //                           opened={multiFlight.showArrival}
                    //                           onChange={() => {
                    //                             const updated = [...multiCity];
                    //                             updated[index] = {
                    //                               ...updated[index],
                    //                               showArrival: !multiFlight.showArrival,
                    //                             };
                    //                             setMultiCity(updated);
                    //                             setDefaultOptions(initialAirports);
                    //                           }}
                    //                         >
                    //                           <Menu.Target>
                    //                             <div className="from-place">
                    //                               <LocationOnOutlinedIcon />
                    //                               <div className="flight-place-name">
                    //                                 {multiFlight?.arrival?.name || "Select Airport"}
                    //                               </div>
                    //                             </div>
                    //                           </Menu.Target>

                    //                           <Menu.Dropdown>
                    //                             <div>
                    //                               <div className="search-input-wrapper">
                    //                                 <span>
                    //                                   <LocationOnOutlinedIcon />
                    //                                 </span>
                    //                                 <input
                    //                                   type="text"
                    //                                   placeholder="Where to?"
                    //                                   onChange={(e) => {
                    //                                     const inputValue = e.target.value;
                    //                                     if (inputValue.length === 0) {
                    //                                       setDefaultOptions(initialAirports);
                    //                                       return;
                    //                                     }
                    //                                     debouncedLoadOptions(
                    //                                       inputValue,
                    //                                       (options) => {
                    //                                         setDefaultOptions(options);
                    //                                       }
                    //                                     );
                    //                                   }}
                    //                                 />
                    //                               </div>
                    //                               <div className="search-flight-list">
                    //                                 {defaultOptions.length > 0 ? (
                    //                                   defaultOptions.map((option, i) => (
                    //                                     <span
                    //                                       className="flight-dropdown-item"
                    //                                       key={i}
                    //                                       onClick={(e) => {
                    //                                         e.stopPropagation();

                    //                                         const updated = [...multiCity];
                    //                                         updated[index] = {
                    //                                           ...updated[index],
                    //                                           arrival: option,
                    //                                           showArrival: false,
                    //                                         };
                    //                                         setMultiCity(updated);
                    //                                       }}
                    //                                     >
                    //                                       <AirplanemodeActiveOutlinedIcon />
                    //                                       {option.name}{" "}
                    //                                       <span className="iata_code">
                    //                                         ({option.iata})
                    //                                       </span>
                    //                                     </span>
                    //                                   ))
                    //                                 ) : (
                    //                                   <span
                    //                                     style={{
                    //                                       padding: "10px",
                    //                                       display: "block",
                    //                                       textAlign: "center",
                    //                                     }}
                    //                                   >
                    //                                     No matching locations found
                    //                                   </span>
                    //                                 )}
                    //                               </div>
                    //                             </div>
                    //                           </Menu.Dropdown>
                    //                         </Menu> */}

                    //                         <span
                    //                           className={`swap-btn`}
                    //                           style={{
                    //                             transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
                    //                           }}
                    //                           onClick={() => {
                    //                             const departure = multiFlight.departure;
                    //                             const arrival = multiFlight.arrival;
                    //                             const updated = [...multiCity];
                    //                             updated[index] = {
                    //                               ...updated[index],
                    //                               arrival: departure,
                    //                               departure: arrival,
                    //                             };
                    //                             setMultiCity(updated);
                    //                           }}
                    //                         >
                    //                           <SwapHorizIcon />
                    //                         </span>
                    //                       </div>

                    //                       <div className="date-wrapper">
                    //                         <div className="from-to-date-wrapper">
                    //                           <div className="from-date">
                    //                             <Menu
                    //                               shadow="md"
                    //                               opened={multiFlight.showDate}
                    //                               onChange={() => {
                    //                                 const updated = [...multiCity];
                    //                                 updated[index] = {
                    //                                   ...updated[index],
                    //                                   showDate: !multiFlight.showDate,
                    //                                 };
                    //                                 setMultiCity(updated);
                    //                               }}
                    //                             >
                    //                               <Menu.Target>
                    //                                 <div
                    //                                   style={{
                    //                                     display: "flex",
                    //                                     alignItems: "stretch",
                    //                                     flex: 1,
                    //                                   }}
                    //                                 >
                    //                                   <span className="date-icon-wrapper">
                    //                                     <DateRangeOutlinedIcon />
                    //                                   </span>
                    //                                   <span
                    //                                     className="date-text"
                    //                                     style={{ paddingRight: "10px" }}
                    //                                   >
                    //                                     {formatDate(multiFlight.date)}
                    //                                   </span>{" "}
                    //                                 </div>
                    //                               </Menu.Target>
                    //                               <Menu.Dropdown>
                    //                                 <div
                    //                                   className="flight-input-dropdown"
                    //                                   style={{ width: "fit-content" }}
                    //                                 >
                    //                                   <DatePicker
                    //                                     value={multiFlight.date}
                    //                                     onChange={(setDate) => {
                    //                                       const updated = [...multiCity];
                    //                                       updated[index] = {
                    //                                         ...updated[index],
                    //                                         date: setDate,
                    //                                         showDate: false,
                    //                                       };
                    //                                       setMultiCity(updated);
                    //                                     }}
                    //                                   />
                    //                                 </div>
                    //                               </Menu.Dropdown>
                    //                             </Menu>
                    //                             <div className="date-btn-wrapper">
                    //                               <span
                    //                                 onClick={() =>
                    //                                   handleMultiCityDateAction(
                    //                                     index,
                    //                                     multiFlight.date,
                    //                                     "minus"
                    //                                   )
                    //                                 }
                    //                               >
                    //                                 <ArrowBackIosOutlinedIcon fontSize="13px" />
                    //                               </span>
                    //                               <span
                    //                                 onClick={() =>
                    //                                   handleMultiCityDateAction(
                    //                                     index,
                    //                                     multiFlight.date,
                    //                                     "add"
                    //                                   )
                    //                                 }
                    //                               >
                    //                                 <ArrowForwardIosOutlinedIcon fontSize="13px" />
                    //                               </span>
                    //                             </div>
                    //                           </div>
                    //                         </div>
                    //                       </div>

                    //                       {multiCity.length > 1 && (
                    //                         <span
                    //                           style={{ cursor: "pointer" }}
                    //                           onClick={() => {
                    //                             const updated = multiCity.filter(
                    //                               (_, i) => i !== index
                    //                             );
                    //                             setMultiCity(updated);
                    //                           }}
                    //                         >
                    //                           <ClearIcon />
                    //                         </span>
                    //                       )}
                    //                     </div>
                    //                   );
                  })}

                  <button
                    className="add-flight-btn"
                    onClick={() => {
                      const newAdd = {
                        departure: {},
                        arrival: {},
                        date: formattedToday,
                        showDate: false,
                        showDeparture: false,
                        showArrival: false,
                      };
                      setMultiCity([...multiCity, newAdd]);
                    }}
                  >
                    Add Flight
                  </button>
                </>
              )}
              <div className="filter_section">
                <div style={{ position: "relative" }}>
                  <div
                    className="all-filter-btn"
                    onClick={() => setAllFilterOpen((prev) => !prev)}
                  >
                    <TuneOutlinedIcon fontSize="17px" />
                    All filters
                  </div>

                  {allFilterOpen && (
                    <div className="all-filters-dropdown">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "15px 20px",
                          fontWeight: "500",
                        }}
                      >
                        Filters{" "}
                        <span
                          onClick={() => setAllFilterOpen(false)}
                          style={{ cursor: "pointer" }}
                        >
                          <CloseIcon />
                        </span>
                      </div>
                      <div style={{ height: "250px", overflow: "auto" }}>
                        <Stops stops={stops} setStops={setStops} />

                        <Bags bags={bags} setBags={setBags} />

                        <Price price={price} setPrice={setPrice} />

                        <Times
                          departureTime={departureTime}
                          setDepartureTime={setDepartureTime}
                          arrivalTime={arrivalTime}
                          setArrivalTime={setArrivalTime}
                        />

                        <Duration
                          duration={duration}
                          setDuration={setDuration}
                        />

                        <Airlines
                          airlines={airlines}
                          setAirlines={setAirlines}
                          checkedAirline={checkedAirline}
                          setCheckedAirline={setCheckedAirline}
                        />

                        <Airports
                          layoverStops={layoverStops}
                          setLayoverStops={setLayoverStops}
                          checkedAirport={checkedAirport}
                          setCheckedAirport={setCheckedAirport}
                        />
                      </div>

                      <div
                        style={{
                          padding: "15px 20px",
                          color: "#f00",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        onClick={clearFilters}
                      >
                        <span>Clear</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="filter-container">
                  {showLeft && (
                    <button className="scroll-btn left" onClick={scrollToStart}>
                      <ArrowBackIosOutlinedIcon fontSize="12px" />
                    </button>
                  )}
                  <div className="filters-wrapper" ref={wrapperRef}>
                    {filters.map((filter, index) => {
                      let component;
                      const showValue =
                        filter.filterValue !== null &&
                        filter.filterValue !== "";

                      switch (filter.key) {
                        case "stops":
                          component = (
                            <Stops stops={stops} setStops={setStops} />
                          );
                          break;
                        case "bags":
                          component = <Bags bags={bags} setBags={setBags} />;
                          break;
                        case "price":
                          component = (
                            <Price price={price} setPrice={setPrice} />
                          );
                          break;

                        case "times":
                          component = (
                            <Times
                              departureTime={departureTime}
                              setDepartureTime={setDepartureTime}
                              arrivalTime={arrivalTime}
                              setArrivalTime={setArrivalTime}
                            />
                          );
                          break;

                        case "duration":
                          component = (
                            <Duration
                              duration={duration}
                              setDuration={setDuration}
                            />
                          );
                          break;

                        case "currency":
                          component = (
                            <Currency
                              currency={currency}
                              setCurrency={setCurrency}
                            />
                          );
                          break;

                        case "airlines":
                          component = (
                            <Airlines
                              airlines={airlines}
                              setAirlines={setAirlines}
                              checkedAirline={checkedAirline}
                              setCheckedAirline={setCheckedAirline}
                            />
                          );
                          break;

                        case "airports":
                          component = (
                            <Airports
                              layoverStops={layoverStops}
                              setLayoverStops={setLayoverStops}
                              checkedAirport={checkedAirport}
                              setCheckedAirport={setCheckedAirport}
                            />
                          );
                          break;
                        default:
                          component = <div>Hello</div>;
                      }

                      return (
                        <Menu
                          shadow="md"
                          position="bottom-start"
                          offset={2}
                          key={index}
                        >
                          <Menu.Target>
                            <span
                              className="trip_wrapper"
                              style={{
                                background: showValue
                                  ? "#228be6"
                                  : "transparent",
                                color: showValue ? "#fff" : "#222",
                                borderColor: showValue ? "transparent" : "#222",
                              }}
                            >
                              {showValue ? (
                                <>
                                  <span className="trip_icon_wrapper">
                                    {filter.filterValue}
                                  </span>

                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();

                                      if (filter.key === "stops") {
                                        setStops("any");
                                      }

                                      if (filter.key === "bags") {
                                        setBags(0);
                                      }

                                      if (filter.key === "price") {
                                        setPrice(99999);
                                      }

                                      if (filter.key === "times") {
                                        setDepartureTime([0, 24]);
                                        setArrivalTime([0, 24]);
                                      }

                                      if (filter.key === "duration") {
                                        setDuration(45);
                                      }

                                      if (filter.key === "airports") {
                                        const airportObject = layoverStops.map(
                                          (stop) => ({
                                            ...stop,
                                            selected: true,
                                          })
                                        );

                                        setLayoverStops(airportObject);
                                      }

                                      if (filter.key === "airlines") {
                                        const airlineObject = airlines.map(
                                          (airline) => ({
                                            ...airline,
                                            selected: true,
                                          })
                                        );

                                        setAirlines(airlineObject);
                                      }

                                      if (filter.key === "currency") {
                                        setCurrency(null);
                                      }
                                      setFilters((prev) =>
                                        prev.map((f) =>
                                          f.key === filter.key
                                            ? { ...f, filterValue: null }
                                            : f
                                        )
                                      );
                                    }}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <CloseIcon fontSize="14px" />
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span className="trip_icon_wrapper">
                                    {filter.filterLabel}
                                  </span>

                                  <ArrowDropDownIcon />
                                </>
                              )}
                            </span>
                          </Menu.Target>

                          <Menu.Dropdown>{component}</Menu.Dropdown>
                        </Menu>
                      );
                    })}
                  </div>

                  {showRight && (
                    <button className="scroll-btn right" onClick={scrollToEnd}>
                      <ArrowForwardIosOutlinedIcon fontSize="12px" />
                    </button>
                  )}
                </div>
              </div>

              <button
                className="search-btn"
                onClick={() => {
                  handleSearch();

                  // if (previousFlight || selectedMultiCityFlights.length > 0) {
                  //   setPreviousFlight(null);
                  //   setSelectedMultiCityFlights([]);
                  //   setShouldSearch(true);
                  // } else {
                  //   handleSearch();
                  // }
                }}
              >
                <SearchOutlinedIcon /> Search
              </button>
            </div>

            <div className="flight-list">
              {loading && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Loading...
                  <Loader color="blue" />
                </div>
              )}

              {!loading && returnFlights && returnFlights.length > 0 && (
                <div
                  className="flight-list-container"
                  style={{ marginTop: "40px" }}
                >
                  <div className="return-flight-header">
                    <img src={previousFlight?.airline_logo} alt="logo" />
                    <span
                      className="return-flight-code"
                      onClick={() => {
                        setPreviousFlight(null);
                        setReturnFlights([]);
                        setShouldSearch(true);
                      }}
                    >
                      {previousFlight?.flights[0]?.departure_airport?.id}
                      <RemoveIcon fontSize="4px" />
                      {previousFlight?.flights.at(-1)?.arrival_airport?.id}
                    </span>
                    <ArrowForwardIosOutlinedIcon sx={{ fontSize: "14px" }} />
                    Choose return to{" "}
                    {previousFlight?.flights[0]?.departure_airport?.name}
                  </div>

                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h3>Returning Flights</h3>

                    <Menu shadow="lg" position="bottom-end" width={200}>
                      <Menu.Target>
                        <span className="sort-wrapper">
                          Sorted by{" "}
                          {shortType === 1
                            ? "top flights"
                            : shortType === 2
                            ? "price"
                            : shortType === 3
                            ? "departure time"
                            : shortType === 4
                            ? "arrival time"
                            : shortType === 5
                            ? "duration"
                            : shortType === 6
                            ? "emissions"
                            : null}{" "}
                          <ArrowDropDownIcon />
                        </span>
                      </Menu.Target>

                      <Menu.Dropdown>
                        <Menu.Item
                          onClick={() => {
                            handleSortChange(1);
                          }}
                        >
                          Top Flights
                        </Menu.Item>

                        {/* <Menu.Item
                          onClick={() => {
                            handleSortChange(2);
                          }}
                        >
                          Price
                        </Menu.Item> */}

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(3);
                          }}
                        >
                          Departure time
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(4);
                          }}
                        >
                          Arrival time
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(5);
                          }}
                        >
                          Duration
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(6);
                          }}
                        >
                          Emissions
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>
                  </div>

                  <div className="flight-list-wrap">
                    {returnFlights.map((flight, index) => {
                      return (
                        <FlightItem
                          flight={flight}
                          key={index}
                          InfantsInSeat={InfantsInSeat}
                          InfantsOnLap={InfantsOnLap}
                          adults={adults}
                          children={children}
                          handleMinus={handleMinus}
                          handlePlus={handlePlus}
                          previousFlight={previousFlight}
                          setPreviousFlight={setPreviousFlight}
                          selectedMultiCityFlights={selectedMultiCityFlights}
                          setSelectedMultiCityFlights={
                            setSelectedMultiCityFlights
                          }
                          multiCity={multiCity}
                          showDetails={showDetails}
                          setShowDetails={setShowDetails}
                          setFlightDetailsData={setFlightDetailsData}
                        />
                      );
                    })}
                  </div>
                </div>
              )}

              {!loading && multiCityFlights && multiCityFlights.length > 0 && (
                <div
                  className="flight-list-container"
                  style={{ marginTop: "40px" }}
                >
                  <div className="return-flight-header">
                    {selectedMultiCityFlights.map((multiFlight, index) => {
                      return (
                        <>
                          <span
                            className="return-flight-code"
                            onClick={() => {
                              // setPreviousFlight(null);
                              // setReturnFlights([]);
                            }}
                          >
                            {multiFlight?.flights[0]?.departure_airport?.id}
                            <RemoveIcon fontSize="4px" />
                            {multiFlight?.flights.at(-1)?.arrival_airport?.id}
                          </span>
                          <ArrowForwardIosOutlinedIcon
                            sx={{ fontSize: "14px" }}
                          />
                        </>
                      );
                    })}
                    Choose trip to{" "}
                    {
                      multiCity.at(selectedMultiCityFlights.length)?.arrival
                        ?.name
                    }
                  </div>

                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h3>
                      Top Flights to{" "}
                      {
                        multiCity.at(selectedMultiCityFlights.length)?.arrival
                          ?.name
                      }
                    </h3>

                    <Menu shadow="lg" position="bottom-end" width={200}>
                      <Menu.Target>
                        <span className="sort-wrapper">
                          Sorted by{" "}
                          {shortType === 1
                            ? "top flights"
                            : shortType === 2
                            ? "price"
                            : shortType === 3
                            ? "departure time"
                            : shortType === 4
                            ? "arrival time"
                            : shortType === 5
                            ? "duration"
                            : shortType === 6
                            ? "emissions"
                            : null}{" "}
                          <ArrowDropDownIcon />
                        </span>
                      </Menu.Target>

                      <Menu.Dropdown>
                        <Menu.Item
                          onClick={() => {
                            handleSortChange(1);
                          }}
                        >
                          Top Flights
                        </Menu.Item>

                        {/* <Menu.Item
                          onClick={() => {
                            handleSortChange(2);
                          }}
                        >
                          Price
                        </Menu.Item> */}

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(3);
                          }}
                        >
                          Departure time
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(4);
                          }}
                        >
                          Arrival time
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(5);
                          }}
                        >
                          Duration
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(6);
                          }}
                        >
                          Emissions
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>
                  </div>

                  <div className="flight-list-wrap">
                    {multiCityFlights.map((flight, index) => {
                      return (
                        <FlightItem
                          flight={flight}
                          key={index}
                          InfantsInSeat={InfantsInSeat}
                          InfantsOnLap={InfantsOnLap}
                          adults={adults}
                          children={children}
                          handleMinus={handleMinus}
                          handlePlus={handlePlus}
                          previousFlight={previousFlight}
                          setPreviousFlight={setPreviousFlight}
                          selectedMultiCityFlights={selectedMultiCityFlights}
                          setSelectedMultiCityFlights={
                            setSelectedMultiCityFlights
                          }
                          multiCity={multiCity}
                          showDetails={showDetails}
                          setShowDetails={setShowDetails}
                          setFlightDetailsData={setFlightDetailsData}
                        />
                      );
                    })}
                  </div>
                </div>
              )}

              {!loading && bestFlights && bestFlights.length > 0 && (
                <div className="flight-list-container">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h3>Best Flights</h3>
                    <Menu shadow="lg" position="bottom-end" width={200}>
                      <Menu.Target>
                        <span className="sort-wrapper">
                          Sorted by{" "}
                          {shortType === 1
                            ? "top flights"
                            : shortType === 2
                            ? "price"
                            : shortType === 3
                            ? "departure time"
                            : shortType === 4
                            ? "arrival time"
                            : shortType === 5
                            ? "duration"
                            : shortType === 6
                            ? "emissions"
                            : null}{" "}
                          <ArrowDropDownIcon />
                        </span>
                      </Menu.Target>

                      <Menu.Dropdown>
                        <Menu.Item
                          onClick={() => {
                            handleSortChange(1);
                          }}
                        >
                          Top Flights
                        </Menu.Item>

                        {/* <Menu.Item
                          onClick={() => {
                            handleSortChange(2);
                          }}
                        >
                          Price
                        </Menu.Item> */}

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(3);
                          }}
                        >
                          Departure time
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(4);
                          }}
                        >
                          Arrival time
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(5);
                          }}
                        >
                          Duration
                        </Menu.Item>

                        <Menu.Item
                          onClick={() => {
                            handleSortChange(6);
                          }}
                        >
                          Emissions
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>
                  </div>

                  <div className="flight-list-wrap">
                    {bestFlights.map((flight, index) => {
                      return (
                        <FlightItem
                          flight={flight}
                          key={index}
                          InfantsInSeat={InfantsInSeat}
                          InfantsOnLap={InfantsOnLap}
                          adults={adults}
                          children={children}
                          handleMinus={handleMinus}
                          handlePlus={handlePlus}
                          previousFlight={previousFlight}
                          setPreviousFlight={setPreviousFlight}
                          selectedMultiCityFlights={selectedMultiCityFlights}
                          setSelectedMultiCityFlights={
                            setSelectedMultiCityFlights
                          }
                          multiCity={multiCity}
                          showDetails={showDetails}
                          setShowDetails={setShowDetails}
                          setFlightDetailsData={setFlightDetailsData}
                        />
                      );
                    })}
                  </div>
                </div>
              )}

              {!loading && otherFlights && otherFlights.length > 0 && (
                <div
                  className="flight-list-container"
                  style={{ marginTop: "40px" }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h3>Other Flights</h3>

                    {bestFlights.length === 0 && (
                      <Menu shadow="lg" position="bottom-end" width={200}>
                        <Menu.Target>
                          <span className="sort-wrapper">
                            Sorted by{" "}
                            {shortType === 1
                              ? "top flights"
                              : shortType === 2
                              ? "price"
                              : shortType === 3
                              ? "departure time"
                              : shortType === 4
                              ? "arrival time"
                              : shortType === 5
                              ? "duration"
                              : shortType === 6
                              ? "emissions"
                              : null}{" "}
                            <ArrowDropDownIcon />
                          </span>
                        </Menu.Target>

                        <Menu.Dropdown>
                          <Menu.Item
                            onClick={() => {
                              handleSortChange(1);
                            }}
                          >
                            Top Flights
                          </Menu.Item>

                          <Menu.Item
                            onClick={() => {
                              handleSortChange(2);
                            }}
                          >
                            Price
                          </Menu.Item>

                          <Menu.Item
                            onClick={() => {
                              handleSortChange(3);
                            }}
                          >
                            Departure time
                          </Menu.Item>

                          <Menu.Item
                            onClick={() => {
                              handleSortChange(4);
                            }}
                          >
                            Arrival time
                          </Menu.Item>

                          <Menu.Item
                            onClick={() => {
                              handleSortChange(5);
                            }}
                          >
                            Duration
                          </Menu.Item>

                          <Menu.Item
                            onClick={() => {
                              handleSortChange(6);
                            }}
                          >
                            Emissions
                          </Menu.Item>
                        </Menu.Dropdown>
                      </Menu>
                    )}
                  </div>

                  <div className="flight-list-wrap">
                    {otherFlights.map((flight, index) => {
                      return (
                        <FlightItem
                          flight={flight}
                          key={index}
                          InfantsInSeat={InfantsInSeat}
                          InfantsOnLap={InfantsOnLap}
                          adults={adults}
                          children={children}
                          handleMinus={handleMinus}
                          handlePlus={handlePlus}
                          previousFlight={previousFlight}
                          setPreviousFlight={setPreviousFlight}
                          selectedMultiCityFlights={selectedMultiCityFlights}
                          setSelectedMultiCityFlights={
                            setSelectedMultiCityFlights
                          }
                          multiCity={multiCity}
                          showDetails={showDetails}
                          setShowDetails={setShowDetails}
                          setFlightDetailsData={setFlightDetailsData}
                        />
                      );
                    })}
                  </div>
                </div>
              )}

              {!loading &&
                otherFlights.length === 0 &&
                bestFlights.length === 0 &&
                returnFlights.length === 0 &&
                multiCityFlights.length === 0 && (
                  <div style={{ textAlign: "center" }}>No Flights</div>
                )}
            </div>
          </div>
        )}
      </React.Fragment>
    </div>
  );
};

export default NewFlightSearch;
